documentsToCollect.classy.controller({
    name: 'DocumentsToCollectModalController',
    inject: ['$scope', '$sce', 'index', 'authServiceFactory', 'DateService', 'RestService', 'InformationService', 'PutService', 'PostService',
        'PurgeService', 'ModelService', 'DocumentsModelService', 'SchoolModelService', 'StandardModalCudFactory', '$modalInstance'],
    init: function()
    {
        if (this.index == 1) {
            let domain = this.authServiceFactory.getDomain();
            this.$.modalURL = "https://" + domain + "/family_side/faTaxWizDemo.php?schoolID="+this.authServiceFactory.getAuth().schoolID+"&done=2";
            this.$.modalURL = this.$sce.trustAsResourceUrl(this.$.modalURL);
        }
        this.$.index = this.index;
        this.$.$modalInstance = this.$modalInstance;
        this.$.items = this.DocumentsModelService.get();
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.separate(this.$.schoolinfo.taxDocuments);
        this.$.currentYear = this.DateService.getCurrentYear();
    },
    separate: function(doc) 
    {

        this.$.documentarray = [];
        let sNumber = doc.toString();

        for (var i=0, len=sNumber.length; i < len; i += 1) {
            this.$.documentarray.push(+sNumber.charAt(i)); 
        }

    }
});